import { token } from '../../__generated__/tokens';

export const TERRA_GRAPH_CATEGORY_TOKEN_PATHS = [
  'colors.bg.graphs.purple',
  'colors.bg.graphs.blue',
  'colors.bg.graphs.orange',
  'colors.bg.graphs.sky',
  'colors.bg.graphs.pink',
  'colors.bg.graphs.gray',
  'colors.bg.graphs.low',
  'colors.bg.graphs.medium',
  'colors.bg.graphs.high',
  'colors.bg.graphs.critical',
] as const;

export function getTerraGraphCategoryColors(): string[] {
  return TERRA_GRAPH_CATEGORY_TOKEN_PATHS.map((path) => token(path));
}

export function getTerraGraphSeriesColor(): string {
  return token(TERRA_GRAPH_CATEGORY_TOKEN_PATHS[0]);
}
